import { ENGLISH_TRANSLATIONS } from './translation/en'
import { GERMAN_TRANSLATIONS } from './translation/de'
import { FRENCH_TRANSLATIONS } from './translation/fr'

export default {
  supported_languages: {
    en: ENGLISH_TRANSLATIONS,
    de: GERMAN_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS
  }
}
